export const CREATE_CLIENT_SUCCESS = "CREATE_CLIENT_SUCCESS"
export const CREATE_CLIENT_FAIL = "CREATE_CLIENT_FAIL"

export const LIST_CLIENT_SUCCESS = "LIST_CLIENT_SUCCESS"
export const LIST_CLIENT_FAIL = "LIST_CLIENT_FAIL"

export const SHOW_CLIENT_SUCCESS = "SHOW_CLIENT_SUCCESS"
export const SHOW_CLIENT_FAIL = "SHOW_CLIENT_FAIL"

export const UPDATE_CLIENT_SUCCESS = "UPDATE_CLIENT_SUCCESS"
export const UPDATE_CLIENT_FAIL = "UPDATE_CLIENT_FAIL"

export const DELETE_CLIENT_SUCCESS = "DELETE_CLIENT_SUCCESS"
export const DELETE_CLIENT_FAIL = "DELETE_CLIENT_FAIL"

export const DELETE_ALL_CLIENT_SUCCESS = "DELETE_ALL_CLIENT_SUCCESS"
export const DELETE_ALL_CLIENT_FAIL = "DELETE_ALL_CLIENT_FAIL"

export const SEARCH_CLIENT_SUCCESS = "SEARCH_CLIENT_SUCCESS"
export const SEARCH_CLIENT_FAIL = "SEARCH_CLIENT_FAIL"

export const UPLOAD_EXCEL_CLIENT_SUCCESS = "UPLOAD_EXCEL_CLIENT_SUCCESS"
export const UPLOAD_EXCEL_CLIENT_FAIL = "UPLOAD_EXCEL_CLIENT_FAIL"

export const LIST_ADMINS_SUCCESS = "LIST_ADMINS_SUCCESS";
export const LIST_ADMINS_FAIL = "LIST_ADMINS_FAIL";

export const UPDATE_ADMIN_SUCCESS = "UPDATE_ADMIN_SUCCESS";
export const UPDATE_ADMIN_FAIL = "UPDATE_ADMIN_FAIL";

export const LIST_MANAGER_SUCCESS = "LIST_MANAGER_SUCCESS"
export const LIST_MANAGER_FAIL = "LIST_MANAGER_FAIL"